(function () {
	'use strict';
	$(document).ready(function () {
		let currentPage = 1;
		const jobOffersForm = $('.job-offers-form');
		const jobOffersWrapper = $('.offers-wrapper');
		const offersList = $('.offers-list');
		const singleJobModal = $('.single-job-offer-modal');

		$('#load-more').on('click', function (event) {
			event.preventDefault();
			offersList.addClass('loading');
			currentPage++;
			get_job_offers();
		});

		clickedOutside('.chosen-department + .select-wrapper', () => {
			$('.chosen-department + .select-wrapper').slideUp();
		}, ['.chosen-department']);

		clickedOutside('.chosen-seniority + .select-wrapper', () => {
			$('.chosen-seniority + .select-wrapper').slideUp();
		}, ['.chosen-seniority']);

		jobOffersForm.find('.chosen-department, .chosen-seniority').on('click', function () {
			$(this).siblings('.select-wrapper').slideToggle();
		});

		jobOffersForm.find('.select-wrapper li button').on('click', function () {
			const button = $(this);
			const wrapper = $(this).parents('.select-wrapper');
			wrapper.slideUp();
			wrapper.siblings('button').text(button.data('name'));
			wrapper.siblings('input[type="hidden"]').val(button.data('id'));
		});

		jobOffersForm.on('submit', function (event) {
			event.preventDefault();
			offersList.addClass('loading');
			currentPage = 1;
			get_job_offers(true);
		});

		offersList.on('click', '.job-offer-button', function () {
			offersList.addClass('loading');
			const id = $(this).data('id');
			showSingleOffer(id);
		});

		singleJobModal.on('click', 'button.copy-link-button', function () {
			const button = $(this);
			navigator.clipboard.writeText(window.location.href).then(function() {
				button.text('Copied');
				console.log('Copied!');
			}, function() {
				button.text('Copy error');
				console.log('Copy error')
			});
		});
		singleJobModal.find('button.close-button').on('click', function () {
			$(this).parents('.single-job-offer-modal').removeClass('open');
			clearURL();
		});
		clickedOutside('.single-job-wrapper', () => {
			singleJobModal.removeClass('open');
			clearURL();
		}, ['single-job-wrapper']);

		function showSingleOffer(id) {
			$.ajax({
				type: 'POST',
				url: window.fh_config.ajax_url,
				dataType: 'json',
				data: {
					action: 'get_single_job_offer',
					id,
				},
				success: function (res) {
					singleJobModal.find('.content').html(res.html);
					singleJobModal.find('#job-apply-button').attr('href', res.link);
					singleJobModal.addClass('open');
					offersList.removeClass('loading');
					window.history.pushState(
						{},
						$('title').text(),
						window.fh_config.page_url + '?job_id=' + id + '&title=' + res.title,
					);
				},
			});
		}

		function clearURL() {
			window.history.pushState(
				{},
				$('title').text(),
				window.fh_config.page_url,
			);
		}

		function get_job_offers(resetList = false) {
			const department = jobOffersForm.find('#department').val();
			const seniority = jobOffersForm.find('#seniority').val();
			$.ajax({
				type: 'POST',
				url: window.fh_config.ajax_url,
				dataType: 'json',
				data: {
					action: 'get_job_offers',
					paged: currentPage,
					department,
					seniority
				},
				success: function (res) {
					jobOffersWrapper.show();
					if(currentPage >= res.max) {
						$('#load-more').hide();
					}
					else {
						$('#load-more').show();
					}
					if (resetList) {
						offersList.html(res.html);
					}
					else {
						offersList.append(res.html);
					}
					offersList.removeClass('loading');
				}
			});
		}
	});
}(jQuery));
